/* tslint:disable */

declare var Object: any;
export interface TtadleaverequestdetailInterface {
  "requestNo": string;
  "companyId": number;
  "leaveDate": Date;
  "leaveStarttime"?: Date;
  "leaveEndtime"?: Date;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate"?: Date;
  "cancelsts"?: string;
  "dayrequesttype"?: string;
  ttadleaverequest?: any;
  tcltrequests?: any;
}

export class Ttadleaverequestdetail implements TtadleaverequestdetailInterface {
  "requestNo": string;
  "companyId": number;
  "leaveDate": Date;
  "leaveStarttime": Date;
  "leaveEndtime": Date;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "cancelsts": string;
  "dayrequesttype": string;
  ttadleaverequest: any;
  tcltrequests: any;
  constructor(data?: TtadleaverequestdetailInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttadleaverequestdetail`.
   */
  public static getModelName() {
    return "Ttadleaverequestdetail";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttadleaverequestdetail for dynamic purposes.
  **/
  public static factory(data: TtadleaverequestdetailInterface): Ttadleaverequestdetail{
    return new Ttadleaverequestdetail(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttadleaverequestdetail',
      plural: 'Ttadleaverequestdetails',
      path: 'Ttadleaverequestdetails',
      properties: {
        "requestNo": {
          name: 'requestNo',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "leaveDate": {
          name: 'leaveDate',
          type: 'Date'
        },
        "leaveStarttime": {
          name: 'leaveStarttime',
          type: 'Date'
        },
        "leaveEndtime": {
          name: 'leaveEndtime',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "cancelsts": {
          name: 'cancelsts',
          type: 'string'
        },
        "dayrequesttype": {
          name: 'dayrequesttype',
          type: 'string'
        },
      },
      relations: {
        ttadleaverequest: {
          name: 'ttadleaverequest',
          type: 'any',
          model: ''
        },
        tcltrequests: {
          name: 'tcltrequests',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttadleaverequestdetail.ts